<template>
   <div class="footer">本产品由来村网提供技术支持</div>
</template>
<script>
import { ref, onMounted } from "vue";

export default {
  name: "baseBar",
  props: {
    title: {
      type: String,
      default: () => {},
    }
  },
  setup(props) {

    onMounted(() => {
     
      
    });
    return {
      
    };
  },
};

</script>
<style lang="less" scoped>
    .footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
</style>
